import React, {useState, useEffect } from 'react'
import {
    Menu,
    MenuItem,
    IconButton,
    Divider,
    ListSubheader,
    Typography

} from '@material-ui/core';
import TuneIcon from '@material-ui/icons/Tune';
import { TemplateChoices } from '../NavBar/NavBar'
import VersionTemplateManager, { TemplateSelection } from '../../../Utils/VersionTemplate'

interface Props {
    onSet?: (selectedTemplates: TemplateSelection)=> void,
    templateChoices?: TemplateChoices

}

const defaultTemplateChoices: TemplateChoices = {
    "Event Seqeunce Diagram": ['v1'],
    "Fault Tree": ['v1', 'v2'],
    "Bayesian Network": ['v1']
}

const versionTemplateManager = new VersionTemplateManager()

const TemplateSelectionButton = (props: Props) => {

    const [open, setOpen] = useState<boolean>(false)
    const [anchorEl, setAnchorEl] = useState(null)

    const startingTemplateChoices = props.templateChoices ? props.templateChoices : defaultTemplateChoices
    const [versionByTreeType, setVersionByTreeType] = useState<TemplateChoices>(startingTemplateChoices)

    const [selectedVersions, setSelectedVersions] = useState<TemplateSelection>(versionTemplateManager.templates)

    useEffect(()=>{
        // should the template options ever by generated from API request
        // this will set the options 
        if(props.templateChoices){
            setVersionByTreeType(props.templateChoices)
        }
    },[props.templateChoices])


    /**
     * Saves the toggled version for template icon on NavBar
     * @param treeType The tree type of the selection
     * @param version The version that is toggled
     */
    const setSelectedVersionsLocal = (treeType: string, version: string) =>{
        const { onSet } = props;
        const newSelection: TemplateSelection = {...selectedVersions, [treeType]: version}
        // sets the current state to new selection
        setSelectedVersions(newSelection)
        // store new selection to local storage
        versionTemplateManager.setStoredTemplates(newSelection)
        // invokes cb with new selection
        if (onSet){
            onSet(newSelection)
        }
    }
    
    /**
     * Opens the menu by setting open to true
     * @returns
     */
    const handleOpen = (): void => setOpen(true)

    /**
     * Sets the location of the menu to the icon that was clicked
     * and opens the menu
     * @param e
     */
    const handleClick = (e): void =>{
        setAnchorEl(e.currentTarget)
        handleOpen()
    }

    /**
     * Closes the menu by setting open to false
     * @returns 
     */
    const handleClose = (): void => setOpen(false)

    return (
        <>
            <IconButton
            aria-owns={open ? 'menu-settingsbar' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
            color="inherit"
            >
                <TuneIcon />
            </IconButton>
            <Menu 
                anchorEl={anchorEl}
                open={open} 
                onClose={handleClose}
                style={{width: "100%"}}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
                }}
                MenuListProps={{
                    subheader: <ListSubheader component="div">Templates</ListSubheader>,
                    disablePadding: true,
                    dense: true,
                }}
            >
               <Divider/>
                {
                    Object.entries(versionByTreeType).map(([key, values], idx)=>{
                        return (
                            <>
                                <div style={{width: 250}}>
                                    <Typography style={{padding: "10px 0px 0px 10px"}} variant='body2'>
                                        {key}
                                    </Typography>
                                    <div style={{display: 'flex', justifyContent: "flex-end"}}>
                                        {
                                            values.map((value: string)=>{
                                                const selected = value == selectedVersions[key]
                                                return (
                                                    <div style={{paddingBottom: 5, marginRight: 5}}>
                                                        <MenuItem
                                                            selected={selected}
                                                            value={value}
                                                            onClick={()=>setSelectedVersionsLocal(key, value)}
                                                        >
                                                            {value}
                                                        </MenuItem>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <Divider/>
                            </>
                        )
                    })
                }
               <Divider/>
            </Menu>
        </>
    )
}

export default TemplateSelectionButton